var $, Boxes, Main, Scroll;

$ = require('jquery');

Main = require('./main');

Boxes = require('./boxes');

Scroll = require('./scroll');

module.exports = $(document).ready(function() {
  return console.log('doc ready');
});
